import { getFluxImageUrl } from '@utils/utils';
import { getBaseUrl } from '@utils/environmentUtils';
import { getSearchParams } from '@modules/updateUrls';
import type { HotelBoxData } from '@interfaces/components/hotelBoxData';
import type { BestAccommodationOfferForHotelList } from '@/interfaces/api/v1-best-accommodation-offer-for-hotel-list';
import type { BestPackageOfferForHotelList } from '@/interfaces/api/v1-best-package-offer-for-hotel-list';
import { Board } from '@/js/data/board-types';
import { extractTravelTypeFromOffer } from '@/js/utils/offerUtils';

const fluxImageUrl = getFluxImageUrl();
const baseUrl = getBaseUrl();

const transformHotelBoxData = (
	offer: BestAccommodationOfferForHotelList | BestPackageOfferForHotelList,
	extendUrl: string
): HotelBoxData => ({
	Name: offer.Hotel.Name,
	HotelIffCode: offer.Hotel.IffCode,
	Url: `${baseUrl}${offer.Hotel.URL}${extendUrl}`,
	CityName: offer.Location.City.CityName,
	RegionName: offer.Location.Region.RegionName,
	CountryName: offer.Location.Country.CountryName,
	Category: offer.Hotel.Category,
	MeanRatingOverall: offer.Ratings.Overall,
	TravelDuration: extractTravelTypeFromOffer(offer).OvernightStays,
	BoardType: Board[extractTravelTypeFromOffer(offer).Board],
	TourOperator: extractTravelTypeFromOffer(offer).TourOperator,
	Location: offer.Location,
	Price: offer.Pricing.Total.Converted ?? offer.Pricing.Total.Amount,
	Image: {
		l: `${fluxImageUrl}/hotel/${offer.Hotel.IffCode}/1/l`,
		m: `${fluxImageUrl}/hotel/${offer.Hotel.IffCode}/1/m`,
		s: `${fluxImageUrl}/hotel/${offer.Hotel.IffCode}/1/s`,
	},
});

export const transformList = (hotelList: BestPackageOfferForHotelList[] | BestAccommodationOfferForHotelList[]): HotelBoxData[] => {
	const params = getSearchParams();
	const extendUrl = params === '' ? '' : `?${params}`;

	const data = hotelList.map((hotel) => transformHotelBoxData(hotel as BestPackageOfferForHotelList, extendUrl));
	return data;
};
